import BaseLayout from './components/base-layout-switcher'

export default BaseLayout
